import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { SearchInputLayout } from './styles';

export const SearchInput = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SearchInputLayout>
      <input
        type="text"
        placeholder={t('Search guideline')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <i className="bx bx-search" />
    </SearchInputLayout>
  );
};

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
